export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/activities', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/activity', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/activity/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/activity/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/activity/' + data.id, { params: data.filters || {} })
  }
})
